jQuery(document).foundation($);

jQuery(document).ready(function($) {
    //Abrir preguntes frequents por url
    let url = window.location.href;
    if(url.lastIndexOf('#') > -1){
        let id = url.substring(url.lastIndexOf('#') + 1);
        if(id){
            let dataTarget = $('#'+id+' > a');
            let dataParent = $('#'+id).parent();
            let dataDiv = $('#'+id+' > div');
            setTimeout(function(){
                if(dataParent){
                    $(dataParent).foundation('toggle',dataTarget);
                    $(dataParent).foundation('down',dataTarget);
                    $(dataParent).foundation('down',dataDiv);
                }
                if(dataDiv){
                    $(dataDiv).css('style','block');
                }
            }, 500);
        }

    }


    $( ".faq" ).on( "click", function(e) {
        e.preventDefault();
        let dataParent = $(this).parent().attr('id');
        let url =  window.location.pathname+'#'+dataParent;
        window.history.pushState("object or string", "Title", url);
    });
    /*Menu sticky*/
    $('.title-bar').on('sticky.zf.stuckto:top', function(){
        $(this).addClass('shrink');
    }).on('sticky.zf.unstuckfrom:top', function(){
        $(this).removeClass('shrink');
    });
    /*Anchors selected*/
    $( ".title-anchors" ).on( "click", function() {
        $(".title-anchors").removeClass('selected');
        $(this).addClass("selected");
    });

    /*Get all id from anchors content*/
    let idArray = [];
    $('.entry-content').each(function () {
        idArray.push(this.id);
    });
    $(document).scroll(function () {
        //When scroll pass in id anchor content select menu id ,else remove all menu selected
        let scroll = $(this).scrollTop()+175;
        let lastId = false;
        idArray.forEach((value) => {
            let id = "#"+value;
            if(value){
                let t = $(id).offset().top;
                if (scroll > t) {
                    lastId = id.replace('anchor','title-anchor');
                }
            }

        });
        if(lastId){
            $(".title-anchors").removeClass('selected');
            $(lastId).addClass("selected");
        } else {
            $(".title-anchors").removeClass('selected');
        }
    });



    /*Filtres para el blog*/
    $( ".filter-categories" ).on( "click", function() {
        $(".filter-categories").removeClass('selected');
        $(this).addClass("selected");
       updateBlog();
    });
    $( ".delete" ).on( "click", function(e) {
        e.preventDefault();
        $(".filter-categories").removeClass('selected');
        $("input[name=search]").val('');
       updateBlog();
    });
    $( ".button-search" ).on( "click", function(e) {
        e.preventDefault();
        updateBlog();
    });
    $(document).on('keypress',function(e) {
        if(e.which == 13) {
            e.preventDefault();
            updateBlog();
        }
    });
    $( "input[name=search]" ).change(function() {
        //updateBlog()
    });
    function updateBlog(){
        let path = window.location.pathname;
        //window.location.href = "/blog";
        console.log(path);
        let category = $(".filter-categories.selected").attr("data-id");
        let cpt = $("#cpt").val();
        let grid_columns = $("#grid_columns").val();
        let search =   $("input[name=search]").val();
        let data = {
            'action': 'filterposts',
            'cpt': cpt,
            'grid_columns': grid_columns,
            'category': category,
            'search' : search,
        };
        if(path !== '/noticies/' && path !== '/grups-llavor/'){
            console.log(path);
            let url = cpt === 'grups-llavor' ? '/grups-llavor/' : '/noticies/';
            window.history.pushState("object or string", "Title", url);
            $('main.main').removeClass('medium-7 large-7').addClass('medium-9 large-9');
            $('.posts-number').hide();
        }

        $.ajax({
            url : '/wp-admin/admin-ajax.php',
            data : data,
            type : 'POST',
            beforeSend : function () {
                $('.filtered-posts').html( 'Carregant...' );
            },
            success : function( data ) {
                console.log(data);
                if ( data ) {
                    $('.filtered-posts').html( data.posts );
                } else {
                    $('.filtered-posts').html( 'No posts found.' );
                }
            }
        });
    }
    $( "#main-nav > li" ).hover(function() {
        setTimeout(function(){
            let isStuck = $(".title-bar.is-stuck");
            if (isStuck.length > 0){
                // Do something if class exists
                let div  =  $( "#main-nav > li" );
                for(let i=0;i<div.length; i++){
                    if($( div[i] ).hasClass( "is-active" )) {
                        let height = $( ".js-dropdown-active" ).height();
                        $( isStuck ).css("height",height+80+'px');
                        $( "div.grups" ).css("height",height+113+'px');
                    }
                }
            } else {
                let div  =  $( "#main-nav > li" );
                for(let i=0;i<div.length; i++){
                    if($( div[i] ).hasClass( "is-active" )) {
                        let height = $( ".js-dropdown-active" ).height();
                        $( "header.header" ).css("height",height+80+'px');
                        $( "div.grups" ).css("height",height+113+'px');
                    }
                }

            }


        }, 100);


    });
    $( "#main-nav" ).mouseleave(function() {
        setTimeout(function(){
            let div  =  $( "#main-nav > li" );
            let change = true;
            for(let i=0;i<div.length; i++){
                if($( div[i] ).hasClass( "is-active" )) {
                    change = false;
                }
            }
            if(change){
                let isStuck = $(".title-bar.is-stuck");
                if (isStuck.length > 0){
                    $( isStuck ).css("height",4+'em');
                    $( "div.grups" ).css("height",113+'px');

                } else {
                    $( "header.header" ).css("height",80+'px');
                    $( "div.grups" ).css("height",113+'px');
                }
            }

        }, 500);
    });

});

